var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Box BoxSmall",class:{ Focus: _vm.focus, Active: _vm.active },attrs:{"id":"Button"},on:{"click":_vm._onPress}},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }